import { useEffect, useState } from "react";
import { ToolboxIcon } from "../../icons/toolboxIcon"
import { useServiceCarStore } from "../../store/serviceCarStore";
import { Button } from "../ui/Button"
import { Dialog, DialogContent } from "../ui/Modal"
import { useQuery } from "@tanstack/react-query";
import { getServiceBookingSummeryFn, getServiceLogsFn } from "../../transactions/serviceBooking/serviceBooking";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ServiceIcon } from "../../icons/serviceIcon";
import { CardSkeletion } from "../elements/skeletions/skeletions";


export const ServiceHistory = ({setFormStep}) => {
    const [openModal, setOpenModal] = useState(false);
    const navigate = useNavigate();

    const { flowId } = useParams();
    const [searchParams] = useSearchParams();

    const { carInfo } = useServiceCarStore();

    useEffect(() => {
        if (carInfo.plateno === undefined) {
            navigate(-1)
        }
    }, [carInfo,navigate])
    
    useEffect(() => {
        let paymentHappened = searchParams.get('paymentStatus');
        if (searchParams && paymentHappened) {
          navigate(`/service-booking/summary/${flowId}`);
        }
      },[searchParams,navigate])

    const { isPending, isError, data:historyData, error, isFetching: historyFetching } = useQuery({
        queryKey: ['faq',carInfo],
        queryFn: () => getServiceLogsFn(carInfo.plateno),
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: carInfo.plateno !== undefined && carInfo !== undefined
    })

    const { data: flowData, isFetching } =  useQuery({
        queryKey: [flowId],
        queryFn: () => getServiceBookingSummeryFn(flowId),
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: flowId !== undefined
    })

    return (
        <>
            <div className="flex flex-col gap-6 min-w-[60%]">
                <div className="lg:bg-white rounded-[12px] flex flex-col gap-6 p-6">
                    <div className="flex justify-between items-center">
                        <h4>Ιστορικό Service</h4>
                        <Button className={'rounded-full items-center lg:border lg:border-[#A5A5A5] flex gap-2 py-2 px-5'} onClick={() => { if (carInfo.actions.find(item => item.name === 'booking').enabled) { setFormStep(1); navigate('/service-booking') }else  setOpenModal(true) }}>
                            <ToolboxIcon className={'max-lg:hidden'} />
                            <p className="text-label max-lg:text-[#D4002A]">Νέο Ραντεβού</p>
                        </Button>
                    </div>
                    {historyFetching && <div className="flex flex-col gap-2">
                        <div className="max-lg:bg-white animate-pulse max-lg:p-3 max-lg:rounded-[8px] border-b border-[#F5F5F7] py-3 w-full justify-between flex gap-3">
                                <p className="w-[400px] h-2 bg-powdergrey rounded-full"/>
                                <p className="w-[200px] h-2 bg-powdergrey rounded-full" />
                                <p className="w-[200px] h-2 bg-powdergrey rounded-full"/>
                        </div>
                        <div className="max-lg:bg-white animate-pulse max-lg:p-3 max-lg:rounded-[8px] border-b border-[#F5F5F7] py-3 w-full justify-between flex gap-3">
                                <p className="w-[400px] h-2 bg-powdergrey rounded-full"/>
                                <p className="w-[200px] h-2 bg-powdergrey rounded-full" />
                                <p className="w-[200px] h-2 bg-powdergrey rounded-full"/>
                        </div>
                        <div className="max-lg:bg-white animate-pulse max-lg:p-3 max-lg:rounded-[8px] border-b border-[#F5F5F7] py-3 w-full justify-between flex gap-3">
                                <p className="w-[400px] h-2 bg-powdergrey rounded-full"/>
                                <p className="w-[200px] h-2 bg-powdergrey rounded-full" />
                                <p className="w-[200px] h-2 bg-powdergrey rounded-full"/>
                        </div>
                        <div className="max-lg:bg-white animate-pulse max-lg:p-3 max-lg:rounded-[8px] border-b border-[#F5F5F7] py-3 w-full justify-between flex gap-3">
                                <p className="w-[400px] h-2 bg-powdergrey rounded-full"/>
                                <p className="w-[200px] h-2 bg-powdergrey rounded-full" />
                                <p className="w-[200px] h-2 bg-powdergrey rounded-full"/>
                        </div>
                    </div>}
                    {historyData && <div className="text-body flex flex-col max-lg:gap-4">
                        {historyData.data.length === 0 ? <p>Δεν υπάρχει ιστορικό service.</p> : historyData.data.map((item, index) => (
                            item.CheckinDate !== null && <div className="max-lg:bg-white max-lg:p-3 max-lg:rounded-[8px] border-b border-[#F5F5F7] py-3 w-full justify-between flex" key={index}>
                                <p className="w-[400px]">{item.AssetEventCodeDesc}</p>
                                <p className="w-[200px] text-center">{item.Km} χλμ</p>
                                {item.CheckoutDate !== null ?
                                    <p className="w-[200px]">{item.CheckinDate.split('-')[2] + '/' + item.CheckinDate.split('-')[1] + '/' + item.CheckinDate.split('-')[0]}-{item.CheckoutDate.split('-')[2] + '/' + item.CheckoutDate.split('-')[1] + '/' + item.CheckoutDate.split('-')[0]}</p>
                                    :
                                    <p className="w-[200px]">{item.CheckinDate.split('-')[2] + '/' + item.CheckinDate.split('-')[1] + '/' + item.CheckinDate.split('-')[0]}-</p>
                                }
                            </div>
                        )
                        )}
                    </div>}
                </div>
                {isFetching && 
                <CardSkeletion/>
                }
                {flowData && flowData.data.dataToShow && 
                    <div className="bg-white rounded-[12px] grid lg:grid-cols-2 p-6 gap-6 items-center max-lg:order-first">
                        <div className="border-b border-[#E2E2E2] py-6 lg:hidden flex gap-2">
                            <ServiceIcon />
                            <h5 className="text-[#D4002A]">Επερχόμενο Service</h5>
                        </div>
                        {flowData.data.dataToShow.map(item => {
                            if (item.name === 'works') {
                                return (
                                    <div className="flex flex-col gap-2">
                                        <h6>Είδος εργασίας</h6>
                                        <p className="text-disclaimer w-[90%]">{item.value.join(',')} </p>
                                    </div>
                                )
                            } else if (item.name === 'bookingSelect') {
                                return (
                                    <div className="flex flex-col gap-2">
                                        <h6>Σταθμός εξυπηρέτησης</h6>
                                        <p className="text-disclaimer w-[90%]">{item.value} </p>
                                    </div>
                                )
                            } else if (item.name === 'bookingCalendar') {
                                return (
                                    <div className="flex flex-col gap-2">
                                        <h6>Ημερομηνία & ώρα</h6>
                                        <p className="text-disclaimer w-[90%]">{item.value.split('T')[0].split('-')[2] + '/' +item.value.split('T')[0].split('-')[1] + '/' + item.value.split('T')[0].split('-')[0]}</p>
                                        <p className="text-disclaimer">{new Date(item.value).toLocaleTimeString('el-GR',{
                        timeZone: 'Europe/Athens',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false, // Use 24-hour format
                        hourCycle: 'h23' // Force 2-digit hours
                    })}</p>
                                    </div>
                               )
                            } else {
                                return(<></>)
                            }
                        })}
                        <p className="text-disclaimer w-[90%]">Για να <span className="text-[#D4002A]">ακυρώσεις</span>, επικοινώνησε με την Εξυπηρέτηση Πελατών στο +302106879800.</p>
                    </div>
                    }
            </div>
            <Dialog open={openModal} onOpenChange={(open)=> setOpenModal(open)}>    
                <DialogContent>
                    <div className="bg-white rounded-[12px] p-10 gap-6 flex flex-col items-center">
                        <h3>Απαιτείται προσθήκη οδηγού</h3>
                        <p className="text-body">Για να προγραμματίσεις ραντεβού για service, θα πρέπει να προσθέσεις τουλάχιστον έναν οδηγό στο αυτοκίνητο.</p>
                            <Button onClick={()=>{setOpenModal(false)}} className={'rounded-[6px] bg-[#D4002A] py-3 px-10 text-white h6'}>Κλείσιμο</Button>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}